var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside"
        }
      ],
      staticClass: "grow",
      attrs: {
        "offset-y": "",
        "close-on-content-click": false,
        "nudge-bottom": 2,
        transition: "slide-y-transition"
      },
      nativeOn: {
        click: function($event) {
          $event.stopPropagation()
        }
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on: menu }) {
            return [
              _c(
                "v-card",
                _vm._g(
                  {
                    staticClass: "d-flex my-auto pl-2 pr-2",
                    staticStyle: { border: "solid 1px red" },
                    attrs: {
                      color: "secondarybackground",
                      "full-width": "",
                      "min-width": "400",
                      height: "48"
                    }
                  },
                  menu
                ),
                _vm._l(_vm.selectedEntities, function(item) {
                  return _c(
                    "v-chip",
                    {
                      key: item.entity_nav_full_id,
                      staticClass: "my-auto mx-1",
                      attrs: {
                        color:
                          _vm.selectedEntities === _vm.entities
                            ? "primary"
                            : "lightgrey",
                        small: "",
                        close: "",
                        "text-color":
                          _vm.selectedEntities === _vm.entities
                            ? "opposite"
                            : ""
                      },
                      on: {
                        "update:active": function($event) {
                          return _vm.removeSelectedEntities(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.id + " - " + item.short_name) +
                          "\n      "
                      )
                    ]
                  )
                }),
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "mx-auto",
          staticStyle: { "overflow-y": "auto" },
          attrs: { "full-width": "", "max-height": "500" }
        },
        [
          _c("v-divider"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              label: "Entité",
              flat: "",
              solo: "",
              loading: _vm.loading,
              "hide-details": "",
              clearable: ""
            },
            model: {
              value: _vm.entitiesSearchQuery,
              callback: function($$v) {
                _vm.entitiesSearchQuery = $$v
              },
              expression: "entitiesSearchQuery"
            }
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "ma-0 pa-0" },
            [
              !_vm.entitiesSearchQuery
                ? _c("v-treeview", {
                    attrs: {
                      items: _vm.entitiesItems,
                      "load-children": _vm.fetchChildEntities,
                      transition: "",
                      dense: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function({ item }) {
                            return [
                              _c("v-checkbox", {
                                ref: item.id,
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  dense: "",
                                  "hide-details": "",
                                  color: "primary",
                                  value: item
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prepend",
                                      fn: function() {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(item.id) +
                                                  " - " +
                                                  _vm._s(item.short_name) +
                                                  "\n                " +
                                                  _vm._s(
                                                    item.childcount > 0
                                                      ? `(${item.childcount})`
                                                      : ""
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.selectedEntities,
                                  callback: function($$v) {
                                    _vm.selectedEntities = $$v
                                  },
                                  expression: "selectedEntities"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      839288356
                    )
                  })
                : _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _vm.loading
                        ? _c("p", { staticClass: "pa-5" }, [
                            _vm._v("Chargement..")
                          ])
                        : !_vm.searchEntitiesItems.length
                        ? _c("p", { staticClass: "pa-5" }, [
                            _vm._v(
                              "\n          Aucune entité correspondant à la recherche\n        "
                            )
                          ])
                        : _vm._l(_vm.searchEntitiesItems, function(item) {
                            return _c(
                              "v-list-item",
                              {
                                key: item.title,
                                attrs: { dense: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.updateSelectedEntitiesFromSearchList(
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _c("span", { staticClass: "body-2" }, [
                                    _vm._v(
                                      _vm._s(item.id) +
                                        " - " +
                                        _vm._s(item.name)
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          })
                    ],
                    2
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }